module.exports = __webpack_public_path__ + "static/media/menu-close2.ac691d7c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/icons/menu-close2.svg
// module id = 3183
// module chunks = 7